import { useRef } from "react"
import { remove } from "mobx"
import { observer } from "mobx-react"
import { Button, Image } from "antd"
import { DeleteOutlined, UserOutlined } from "@ant-design/icons"

import { ReplaceIcon } from "@src/app/components/icons/ReplaceIcon"
import { ImageUpload } from "@src/shared/componemts/ImageUploadUI/entity/ImageUpload"
import css from "../index.module.css"

export type ImageUploadPreviewType = {
  control: ImageUpload
  onRemove?: () => void
}
export const ImageUploadPreview = observer(
  ({ control, onRemove }: ImageUploadPreviewType) => {
    const remove = () => {
      if (onRemove) {
        onRemove()
      }
    }

    return (
      <div
        className={css.ImageUploadUI_preview}
        onClick={(e) => e.stopPropagation()}
      >
        <Image
          height="65%"
          src={control.preview as string}
          style={{ height: "100%", objectFit: "contain" }}
          width="100%"
        ></Image>

        <div className={css.ImageUploadUI_actions}>
          <Button
            className={css.ImageUploadUI_button}
            id="GENERATED_ID_IMAGEUPLOADPREVIEW_BUTTON_VOID_1"
            onClick={(e) => {
              control.replace()
            }}
            size="large"
            type="text"
          >
            <div className={css.ImageUploadUI_button_icon}>
              <ReplaceIcon />
            </div>

            <span>Replace image</span>
          </Button>
          <Button
            className={css.ImageUploadUI_button}
            id="GENERATED_ID_IMAGEUPLOADPREVIEW_BUTTON_VOID_2"
            onClick={remove}
            size="large"
            type="text"
          >
            <div className={css.ImageUploadUI_button_icon}>
              <DeleteOutlined />
            </div>

            <span>Delete image</span>
          </Button>
        </div>
      </div>
    )
  },
)
